export const SET_NOT_READ = 'SET_NOT_READ'
export const SET_AUTHTREE = 'SET_AUTHTREE'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js